module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "other-way"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "other-way-option"
  }, [_c('a', {
    attrs: {
      "href": _vm.CONF.APIList.QQLogin + _vm.search + '&channel=' + _vm.channel
    }
  }, [_c('div', {
    staticClass: "option-qq option"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.CONF.APIList.WXLogin + _vm.search + '&isMobile=' + _vm.isMobile + '&channel=' + _vm.channel
    }
  }, [_c('div', {
    staticClass: "option-wx option"
  })]), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "other-way-txt"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "txt font-size14 color-cue"
  }, [_vm._v("其他登录方式")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-255f5854","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/otherWay.vue
// module id = 131
// module chunks = 1